"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Units = void 0;

var _Control = _interopRequireDefault(require("./Control.js"));

var _Units = _interopRequireDefault(require("../proj/Units.js"));

var _css = require("../css.js");

var _proj = require("../proj.js");

var _asserts = require("../asserts.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/control/ScaleLine
 */


/**
 * @type {string}
 */
var UNITS_PROP = 'units';
/**
 * Units for the scale line. Supported values are `'degrees'`, `'imperial'`,
 * `'nautical'`, `'metric'`, `'us'`.
 * @enum {string}
 */

var Units = {
  DEGREES: 'degrees',
  IMPERIAL: 'imperial',
  NAUTICAL: 'nautical',
  METRIC: 'metric',
  US: 'us'
};
/**
 * @const
 * @type {Array<number>}
 */

exports.Units = Units;
var LEADING_DIGITS = [1, 2, 5];
/**
 * @const
 * @type {number}
 */

var DEFAULT_DPI = 25.4 / 0.28;
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:units', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types
 *     |'change:units', Return>} ScaleLineOnSignature
 */

/**
 * @typedef {Object} Options
 * @property {string} [className='ol-scale-line'] CSS Class name.
 * @property {number} [minWidth=64] Minimum width in pixels at the OGC default dpi. The width will be
 * adjusted to match the dpi used.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control
 * should be re-rendered. This is called in a `requestAnimationFrame` callback.
 * @property {HTMLElement|string} [target] Specify a target if you want the control
 * to be rendered outside of the map's viewport.
 * @property {import("./ScaleLine.js").Units|string} [units='metric'] Units.
 * @property {boolean} [bar=false] Render scalebars instead of a line.
 * @property {number} [steps=4] Number of steps the scalebar should use. Use even numbers
 * for best results. Only applies when `bar` is `true`.
 * @property {boolean} [text=false] Render the text scale above of the scalebar. Only applies
 * when `bar` is `true`.
 * @property {number|undefined} [dpi=undefined] dpi of output device such as printer. Only applies
 * when `bar` is `true`. If undefined the OGC default screen pixel size of 0.28mm will be assumed.
 */

/**
 * @classdesc
 * A control displaying rough y-axis distances, calculated for the center of the
 * viewport. For conformal projections (e.g. EPSG:3857, the default view
 * projection in OpenLayers), the scale is valid for all directions.
 * No scale line will be shown when the y-axis distance of a pixel at the
 * viewport center cannot be calculated in the view projection.
 * By default the scale line will show in the bottom left portion of the map,
 * but this can be changed by using the css selector `.ol-scale-line`.
 * When specifying `bar` as `true`, a scalebar will be rendered instead
 * of a scaleline.
 *
 * @api
 */

var ScaleLine =
/** @class */
function (_super) {
  __extends(ScaleLine, _super);
  /**
   * @param {Options} [opt_options] Scale line options.
   */


  function ScaleLine(opt_options) {
    var _this = this;

    var options = opt_options ? opt_options : {};
    var className = options.className !== undefined ? options.className : options.bar ? 'ol-scale-bar' : 'ol-scale-line';
    _this = _super.call(this, {
      element: document.createElement('div'),
      render: options.render,
      target: options.target
    }) || this;
    /***
     * @type {ScaleLineOnSignature<import("../events").EventsKey>}
     */

    _this.on;
    /***
     * @type {ScaleLineOnSignature<import("../events").EventsKey>}
     */

    _this.once;
    /***
     * @type {ScaleLineOnSignature<void>}
     */

    _this.un;
    /**
     * @private
     * @type {HTMLElement}
     */

    _this.innerElement_ = document.createElement('div');
    _this.innerElement_.className = className + '-inner';
    _this.element.className = className + ' ' + _css.CLASS_UNSELECTABLE;

    _this.element.appendChild(_this.innerElement_);
    /**
     * @private
     * @type {?import("../View.js").State}
     */


    _this.viewState_ = null;
    /**
     * @private
     * @type {number}
     */

    _this.minWidth_ = options.minWidth !== undefined ? options.minWidth : 64;
    /**
     * @private
     * @type {boolean}
     */

    _this.renderedVisible_ = false;
    /**
     * @private
     * @type {number|undefined}
     */

    _this.renderedWidth_ = undefined;
    /**
     * @private
     * @type {string}
     */

    _this.renderedHTML_ = '';

    _this.addChangeListener(UNITS_PROP, _this.handleUnitsChanged_);

    _this.setUnits(options.units || Units.METRIC);
    /**
     * @private
     * @type {boolean}
     */


    _this.scaleBar_ = options.bar || false;
    /**
     * @private
     * @type {number}
     */

    _this.scaleBarSteps_ = options.steps || 4;
    /**
     * @private
     * @type {boolean}
     */

    _this.scaleBarText_ = options.text || false;
    /**
     * @private
     * @type {number|undefined}
     */

    _this.dpi_ = options.dpi || undefined;
    return _this;
  }
  /**
   * Return the units to use in the scale line.
   * @return {import("./ScaleLine.js").Units} The units
   * to use in the scale line.
   * @observable
   * @api
   */


  ScaleLine.prototype.getUnits = function () {
    return this.get(UNITS_PROP);
  };
  /**
   * @private
   */


  ScaleLine.prototype.handleUnitsChanged_ = function () {
    this.updateElement_();
  };
  /**
   * Set the units to use in the scale line.
   * @param {import("./ScaleLine.js").Units} units The units to use in the scale line.
   * @observable
   * @api
   */


  ScaleLine.prototype.setUnits = function (units) {
    this.set(UNITS_PROP, units);
  };
  /**
   * Specify the dpi of output device such as printer.
   * @param {number|undefined} dpi The dpi of output device.
   * @api
   */


  ScaleLine.prototype.setDpi = function (dpi) {
    this.dpi_ = dpi;
  };
  /**
   * @private
   */


  ScaleLine.prototype.updateElement_ = function () {
    var viewState = this.viewState_;

    if (!viewState) {
      if (this.renderedVisible_) {
        this.element.style.display = 'none';
        this.renderedVisible_ = false;
      }

      return;
    }

    var center = viewState.center;
    var projection = viewState.projection;
    var units = this.getUnits();
    var pointResolutionUnits = units == Units.DEGREES ? _Units["default"].DEGREES : _Units["default"].METERS;
    var pointResolution = (0, _proj.getPointResolution)(projection, viewState.resolution, center, pointResolutionUnits);
    var minWidth = this.minWidth_ * (this.dpi_ || DEFAULT_DPI) / DEFAULT_DPI;
    var nominalCount = minWidth * pointResolution;
    var suffix = '';

    if (units == Units.DEGREES) {
      var metersPerDegree = _proj.METERS_PER_UNIT[_Units["default"].DEGREES];
      nominalCount *= metersPerDegree;

      if (nominalCount < metersPerDegree / 60) {
        suffix = "\u2033"; // seconds

        pointResolution *= 3600;
      } else if (nominalCount < metersPerDegree) {
        suffix = "\u2032"; // minutes

        pointResolution *= 60;
      } else {
        suffix = "\xB0"; // degrees
      }
    } else if (units == Units.IMPERIAL) {
      if (nominalCount < 0.9144) {
        suffix = 'in';
        pointResolution /= 0.0254;
      } else if (nominalCount < 1609.344) {
        suffix = 'ft';
        pointResolution /= 0.3048;
      } else {
        suffix = 'mi';
        pointResolution /= 1609.344;
      }
    } else if (units == Units.NAUTICAL) {
      pointResolution /= 1852;
      suffix = 'nm';
    } else if (units == Units.METRIC) {
      if (nominalCount < 0.001) {
        suffix = 'μm';
        pointResolution *= 1000000;
      } else if (nominalCount < 1) {
        suffix = 'mm';
        pointResolution *= 1000;
      } else if (nominalCount < 1000) {
        suffix = 'm';
      } else {
        suffix = 'km';
        pointResolution /= 1000;
      }
    } else if (units == Units.US) {
      if (nominalCount < 0.9144) {
        suffix = 'in';
        pointResolution *= 39.37;
      } else if (nominalCount < 1609.344) {
        suffix = 'ft';
        pointResolution /= 0.30480061;
      } else {
        suffix = 'mi';
        pointResolution /= 1609.3472;
      }
    } else {
      (0, _asserts.assert)(false, 33); // Invalid units
    }

    var i = 3 * Math.floor(Math.log(minWidth * pointResolution) / Math.log(10));
    var count, width, decimalCount;

    while (true) {
      decimalCount = Math.floor(i / 3);
      var decimal = Math.pow(10, decimalCount);
      count = LEADING_DIGITS[(i % 3 + 3) % 3] * decimal;
      width = Math.round(count / pointResolution);

      if (isNaN(width)) {
        this.element.style.display = 'none';
        this.renderedVisible_ = false;
        return;
      } else if (width >= minWidth) {
        break;
      }

      ++i;
    }

    var html;

    if (this.scaleBar_) {
      html = this.createScaleBar(width, count, suffix);
    } else {
      html = count.toFixed(decimalCount < 0 ? -decimalCount : 0) + ' ' + suffix;
    }

    if (this.renderedHTML_ != html) {
      this.innerElement_.innerHTML = html;
      this.renderedHTML_ = html;
    }

    if (this.renderedWidth_ != width) {
      this.innerElement_.style.width = width + 'px';
      this.renderedWidth_ = width;
    }

    if (!this.renderedVisible_) {
      this.element.style.display = '';
      this.renderedVisible_ = true;
    }
  };
  /**
   * @private
   * @param {number} width The current width of the scalebar.
   * @param {number} scale The current scale.
   * @param {string} suffix The suffix to append to the scale text.
   * @return {string} The stringified HTML of the scalebar.
   */


  ScaleLine.prototype.createScaleBar = function (width, scale, suffix) {
    var mapScale = '1 : ' + Math.round(this.getScaleForResolution()).toLocaleString();
    var scaleSteps = [];
    var stepWidth = width / this.scaleBarSteps_;
    var backgroundColor = '#ffffff';

    for (var i = 0; i < this.scaleBarSteps_; i++) {
      if (i === 0) {
        // create the first marker at position 0
        scaleSteps.push(this.createMarker('absolute', i));
      }

      scaleSteps.push('<div>' + '<div ' + 'class="ol-scale-singlebar" ' + 'style=' + '"width: ' + stepWidth + 'px;' + 'background-color: ' + backgroundColor + ';"' + '>' + '</div>' + this.createMarker('relative', i) + (
      /*render text every second step, except when only 2 steps */
      i % 2 === 0 || this.scaleBarSteps_ === 2 ? this.createStepText(i, width, false, scale, suffix) : '') + '</div>');

      if (i === this.scaleBarSteps_ - 1) {
        {
          /*render text at the end */
        }
        scaleSteps.push(this.createStepText(i + 1, width, true, scale, suffix));
      } // switch colors of steps between black and white


      if (backgroundColor === '#ffffff') {
        backgroundColor = '#000000';
      } else {
        backgroundColor = '#ffffff';
      }
    }

    var scaleBarText;

    if (this.scaleBarText_) {
      scaleBarText = '<div ' + 'class="ol-scale-text" ' + 'style="width: ' + width + 'px;">' + mapScale + '</div>';
    } else {
      scaleBarText = '';
    }

    var container = '<div ' + 'style="display: flex;">' + scaleBarText + scaleSteps.join('') + '</div>';
    return container;
  };
  /**
   * Creates a marker at given position
   * @param {string} position The position, absolute or relative
   * @param {number} i The iterator
   * @return {string} The stringified div containing the marker
   */


  ScaleLine.prototype.createMarker = function (position, i) {
    var top = position === 'absolute' ? 3 : -10;
    return '<div ' + 'class="ol-scale-step-marker" ' + 'style="position: ' + position + ';' + 'top: ' + top + 'px;"' + '></div>';
  };
  /**
   * Creates the label for a marker marker at given position
   * @param {number} i The iterator
   * @param {number} width The width the scalebar will currently use
   * @param {boolean} isLast Flag indicating if we add the last step text
   * @param {number} scale The current scale for the whole scalebar
   * @param {string} suffix The suffix for the scale
   * @return {string} The stringified div containing the step text
   */


  ScaleLine.prototype.createStepText = function (i, width, isLast, scale, suffix) {
    var length = i === 0 ? 0 : Math.round(scale / this.scaleBarSteps_ * i * 100) / 100;
    var lengthString = length + (i === 0 ? '' : ' ' + suffix);
    var margin = i === 0 ? -3 : width / this.scaleBarSteps_ * -1;
    var minWidth = i === 0 ? 0 : width / this.scaleBarSteps_ * 2;
    return '<div ' + 'class="ol-scale-step-text" ' + 'style="' + 'margin-left: ' + margin + 'px;' + 'text-align: ' + (i === 0 ? 'left' : 'center') + '; ' + 'min-width: ' + minWidth + 'px;' + 'left: ' + (isLast ? width + 'px' : 'unset') + ';"' + '>' + lengthString + '</div>';
  };
  /**
   * Returns the appropriate scale for the given resolution and units.
   * @return {number} The appropriate scale.
   */


  ScaleLine.prototype.getScaleForResolution = function () {
    var resolution = (0, _proj.getPointResolution)(this.viewState_.projection, this.viewState_.resolution, this.viewState_.center, _Units["default"].METERS);
    var dpi = this.dpi_ || DEFAULT_DPI;
    var inchesPerMeter = 1000 / 25.4;
    return parseFloat(resolution.toString()) * inchesPerMeter * dpi;
  };
  /**
   * Update the scale line element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */


  ScaleLine.prototype.render = function (mapEvent) {
    var frameState = mapEvent.frameState;

    if (!frameState) {
      this.viewState_ = null;
    } else {
      this.viewState_ = frameState.viewState;
    }

    this.updateElement_();
  };

  return ScaleLine;
}(_Control["default"]);

var _default = ScaleLine;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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